// extracted by mini-css-extract-plugin
module.exports = {"root":"_3EKyL","left":"_2lYG8","right":"_3ZcLa","small":"_1Co4M","normal":"UQyuh"};